/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { RefinerComponent, SearchBarComponent } from '@msdyn365-commerce/components';
import * as React from 'react';

import { IOrderHistoryWithSearchAndFiltersViewProps } from './custom-order-history';
import {
    OrderHistoryWithSearchAndFiltersHeaderComponent,
    OrderHistoryWithSearchAndFiltersOrganizationWideSelectorComponent
} from './components';
import { IOrderlinksData } from './custom-order-history.props.autogenerated';

const OrderHistoryWithSearchAndFiltersView: React.FC<IOrderHistoryWithSearchAndFiltersViewProps> = props => {
    const {
        orderHistoryWithSearchAndFiltersProps,
        headerProps,
        organizationWideSelectorProps,
        searchBarProps,
        refinerProps,
        alert,
        loading,
        emptyMessage,
        backToShoppingLink,
        list,
        table,
        moreButton
    } = props;

    return props.config.showHomePageVersion ? (
        props.context.request.user.isAuthenticated ? (
            <Module {...orderHistoryWithSearchAndFiltersProps}>
                {headerProps && <OrderHistoryWithSearchAndFiltersHeaderComponent {...headerProps} />}
                <div className='ms-order-history-wrapper'>
                    <div className={`ms-order-history-with-search-and-filters__search-and-filters-wrapper`}>
                        {loading}
                        {alert && (
                            <>
                                {alert}
                                {backToShoppingLink}
                            </>
                        )}
                        {emptyMessage && (
                            <Node className='ms-order-history-with-search-and-filters__empty-message-container'>
                                {emptyMessage}
                                {backToShoppingLink}
                            </Node>
                        )}
                        {table}
                        {props.config.orderlinks && props.config.orderlinks.length > 0 ? (
                            props.config.orderlinks.map((link: IOrderlinksData) => {
                                return (
                                    <a className='msc-btn order-link' key={link.ariaLabel} href={link.linkUrl.destinationUrl}>
                                        {link.linkText}
                                    </a>
                                );
                            })
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </Module>
        ) : (
            <></>
        )
    ) : (
        <Module {...orderHistoryWithSearchAndFiltersProps}>
            {headerProps && <OrderHistoryWithSearchAndFiltersHeaderComponent {...headerProps} />}
            {searchBarProps && <SearchBarComponent {...searchBarProps} />}
            {organizationWideSelectorProps && (
                <OrderHistoryWithSearchAndFiltersOrganizationWideSelectorComponent {...organizationWideSelectorProps} />
            )}
            <div className='ms-order-history-wrapper'>
                <div className='ms-order-history-with-search-and-filters__refiner-wrapper'>
                    {refinerProps && <RefinerComponent {...refinerProps} />}
                </div>
                <div
                    className={`ms-order-history-with-search-and-filters__search-and-filters-wrapper ${
                        refinerProps.isExpanded ? 'filter_expanded' : 'filter_collapsed'
                    }`}
                >
                    {loading}
                    {alert && (
                        <>
                            {alert}
                            {backToShoppingLink}
                        </>
                    )}
                    {emptyMessage && (
                        <Node className='ms-order-history-with-search-and-filters__empty-message-container'>
                            {emptyMessage}
                            {backToShoppingLink}
                        </Node>
                    )}
                    {list}
                    {table}
                    {moreButton && moreButton}
                </div>
            </div>
        </Module>
    );
};

export default OrderHistoryWithSearchAndFiltersView;
